module.exports = __webpack_public_path__ + "static/media/img104_R.15f80d2a.jpg";